export const defaultContent = {
  hero_title: "Meta Reklamlarınızı Hemen Yönetelim",
  hero_subtitle:
    "Daha fazla müşteri, daha güçlü marka, daha verimli reklam bütçesi.",
  whatsapp_number: "905343323111",
  cta_title: "Büyümeniz bizim hedefimiz",
  cta_subtitle: "Ücretsiz analiz görüşmesi için hemen WhatsApp'tan yazın.",
  services: [
    {
      title: "Strateji",
      description:
        "Hedef kitle analizi, rakip analizi ve dönüşüm odaklı funnel kurulumu ile reklam bütçenizin doğru yere gitmesini sağlıyoruz.",
    },
    {
      title: "İçerik Üretimi",
      description:
        "Dönüşüm getiren reklam kreatifleri, video/görsel tasarım ve satış odaklı metin yazarlığı ile markanızı öne çıkarıyoruz.",
    },
    {
      title: "Optimizasyon",
      description:
        "Günlük performans takibi, A/B testler ve ROAS iyileştirme çalışmalarıyla reklamlarınızı sürekli daha verimli hale getiriyoruz.",
    },
  ],
  why_us_points: [
    "Veriye dayalı strateji ile her kararı ölçülebilir sonuçlara bağlıyoruz",
    "Sektörel deneyim: restoran, klinik, emlak ve e-ticaret projelerinde uzmanlık",
    "Haftalık şeffaf raporlama ile bütçenizin nereye gittiğini her zaman görürsünüz",
    "Sözleşmesiz aylık çalışma modeli — istediğiniz zaman özgürce karar verirsiniz",
  ],
  sectors: [
    { title: "Restoran & Kafe", description: "Restoran Instagram reklamı ile masalarınızı doldurun, yerel müşteri akışını artırın." },
    { title: "Klinik & Estetik", description: "Klinik için Meta reklam yönetimi ile randevu taleplerinizi katlayın." },
    { title: "Emlak", description: "Emlak Facebook reklamı ile doğru alıcı ve kiracıya doğrudan ulaşın." },
    { title: "E-ticaret", description: "E-ticaret Meta reklam stratejisiyle satışlarınızı ve ROAS'ınızı yükseltin." },
    { title: "Güzellik & Bakım", description: "Güzellik salonu Instagram reklamı ile randevu defterinizi doldurun." },
    { title: "Yerel Hizmetler", description: "Yerel hizmet işletmeleri için bölgesel hedefli Meta reklam kampanyaları kurguluyoruz." },
  ],
};
